import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { openModal } from '../../redux/modal';
import { fonts, colorPalette, shadows } from '../../styles/styleGuide';
import ImageLoader from '../shared/ui/ImageLoader';
import ButtonSecondary from '../shared/buttons/ButtonSecondary';
import DateIcon from '../shared/designElements/DateIcon';
import DeleteIcon from '../shared/icons/Delete';
import Check from '../shared/icons/Check';
import DaysCounter from '../shared/designElements/DaysCounter';
import truncateText from '../../services/truncateText';
import ObserveSize from '../ObserveSize';
import hasEventPassed from '../../services/hasEventPassed';
import UserAvatar from '../UserAvatar';
import getDate from '../../services/getDate';
var getColor = function getColor(color, variant) {
  return colorPalette["".concat(variant).concat(color)];
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleClick: function handleClick(evt, actionType) {
      evt.preventDefault();
      evt.stopPropagation();
      var _ownProps$match$param = ownProps.match.params,
        projectSlug = _ownProps$match$param.projectSlug,
        env = _ownProps$match$param.env;
      var themeColor = '';
      var endpointConfig = {};
      switch (ownProps.type) {
        case 'update':
        case 'event':
          themeColor = hasEventPassed(ownProps.eventDate) ? getColor('Grey', 'dark') : colorPalette.lightOrange;
          endpointConfig = {
            type: 'article',
            componentProps: {
              projectSlug: projectSlug,
              env: env,
              articleSlug: ownProps.slug,
              planningObj: true
            },
            planningObj: true,
            projectSlug: projectSlug,
            env: env,
            articleSlug: ownProps.slug
          };
          break;
        case 'step':
          themeColor = colorPalette.lightOrange;
          endpointConfig = {
            type: 'planningStep',
            componentProps: {
              id: ownProps.id,
              uniqueId: ownProps.uniqueId,
              type: ownProps.type,
              date: ownProps.date,
              showDate: ownProps.showDate,
              stepNumber: ownProps.stepNumber,
              text: ownProps.text,
              title: ownProps.title,
              subTitle: ownProps.subTitle
            }
          };
          break;
        case 'deadline':
          // Ignore clicks on deadline block BAMECW-2410
          return;
        case 'action':
        default:
          themeColor = colorPalette.lightOrange;
          endpointConfig = {
            type: 'planningAction',
            componentProps: {
              id: ownProps.id,
              mode: actionType,
              blockId: ownProps.blockId,
              uniqueId: ownProps.uniqueId
            }
          };
          break;
      }
      dispatch(openModal(themeColor, endpointConfig));
    }
  };
};
var PlanningCard = /*#__PURE__*/function (_Component) {
  function PlanningCard() {
    var _this;
    _classCallCheck(this, PlanningCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlanningCard, [].concat(args));
    _defineProperty(_this, "state", {
      renderWidth: 0
    });
    _defineProperty(_this, "renderCard", function (props) {
      var renderWidth = _this.state.renderWidth;
      var isCardLarge = renderWidth > 240;
      switch (props.type) {
        case 'update':
          return __jsx(UpdateContainter, {
            "data-id": "dashboard_PlanningCard_UpdateContainter"
          }, __jsx(ImageContainer, {
            "data-id": "dashboard_PlanningCard_ImageContainer"
          }, props.image && __jsx(ImageLoader, {
            src: props.image,
            width: renderWidth + 100,
            mode: "bg",
            "data-id": "dashboard_PlanningCard_ImageLoader"
          })), __jsx(TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, __jsx(PublishedDate, {
            color: "#FFFFFF",
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.publishedDate, false)), __jsx(Title, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Title"
          }, truncateText(props.title, 65)), props.leader && __jsx(Text, {
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.leader, 50)), __jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, __jsx(ButtonSecondary, {
            label: "Lees meer",
            type: "button",
            link: "#",
            color: "#FFFFFF",
            size: isCardLarge ? 'normal' : 'small',
            caretColor: colorPalette.textGrey,
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          }))));
        case 'deadline':
          return __jsx(TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, __jsx(IconHeader, {
            isCardLarge: isCardLarge,
            hasTime: props.hasTime,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, __jsx(DateIconWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DateIconWrapper"
          }, __jsx(DateIcon, {
            textColor: "#FFFFFF",
            bgColor: colorPalette.lightOrange,
            size: isCardLarge ? 'small' : 'mini',
            date: props.eventDate,
            "data-id": "dashboard_PlanningCard_DateIcon"
          })), __jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 65))), __jsx(Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 150)), __jsx(CreatedBy, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CreatedBy"
          }, "Aangemaakt door:", __jsx(Author, {
            "data-id": "dashboard_PlanningCard_Author"
          }, props.author)));
        case 'event':
          var eventPassed = hasEventPassed(props.eventDate);
          return __jsx(TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, __jsx(IconHeader, {
            isCardLarge: isCardLarge,
            hasTime: props.hasTime,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, __jsx(DateIconWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DateIconWrapper"
          }, __jsx(DateIcon, {
            textColor: "#FFFFFF",
            bgColor: eventPassed ? colorPalette.lightBeige : colorPalette.lightOrange,
            size: isCardLarge ? 'small' : 'mini',
            date: props.eventDate,
            "data-id": "dashboard_PlanningCard_DateIcon"
          })), __jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 65))), __jsx(Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 50)), eventPassed && __jsx(PassedEventNotification, {
            "data-id": "dashboard_PlanningCard_PassedEventNotification"
          }, "Dit event ", __jsx("br", {
            "data-id": "dashboard_PlanningCard_br"
          }), "is verlopen"), __jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, __jsx(ButtonSecondary, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));
        case 'step':
          return __jsx(TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, __jsx(IconHeader, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_IconHeader"
          }, __jsx(StepIcon, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_StepIcon"
          }, __jsx("span", {
            "data-id": "dashboard_PlanningCard_span"
          }, "stap"), props.stepNumber), props.showDate && __jsx(PublishedDate, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.date, false)), props.subTitle && __jsx(SubTitle, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_SubTitle"
          }, props.subTitle)), __jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 50)), __jsx(Text, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_Text"
          }, truncateText(props.text, 50)), __jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, __jsx(ButtonSecondary, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));
        case 'action':
        default:
          return __jsx(TextContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TextContainer"
          }, __jsx(PublishedDate, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_PublishedDate"
          }, getDate(props.deadline, false)), __jsx(DaysCounterWrapper, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_DaysCounterWrapper"
          }, __jsx(DaysCounter, {
            deadline: props.deadline,
            fontSize: "12",
            "data-id": "dashboard_PlanningCard_DaysCounter"
          })), __jsx(TitleBig, {
            type: props.type,
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_TitleBig"
          }, truncateText(props.title, 50)), __jsx(Action, {
            isCardLarge: isCardLarge,
            "data-e2e-action-completed": props.accomplished,
            "data-id": "dashboard_PlanningCard_Action"
          }, props.accomplished ? 'Voltooid' : 'Openstaand', props.accomplished && __jsx(CheckContainer, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CheckContainer"
          }, __jsx(Check, {
            color: colorPalette.blue,
            "data-id": "dashboard_PlanningCard_Check"
          }))), __jsx(CreatedBy, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_CreatedBy"
          }, "Aangemaakt door:", __jsx(Author, {
            "data-id": "dashboard_PlanningCard_Author"
          }, props.authorImage && __jsx(UserAvatar, {
            mode: "imageLoader",
            imageUrl: props.authorImage,
            size: "xsmall",
            name: props.author,
            "data-id": "dashboard_PlanningCard_UserAvatar"
          }), props.author)), props.editable && __jsx(DeleteIconContainer, {
            onClick: function onClick(evt) {
              return props.handleClick(evt, 'delete');
            },
            "data-e2e-planningcard-button-delete": true,
            "data-id": "dashboard_PlanningCard_DeleteIconContainer"
          }, __jsx(DeleteIcon, {
            color: colorPalette.blue,
            "data-id": "dashboard_PlanningCard_DeleteIcon"
          })), __jsx(ReadMoreBtn, {
            isCardLarge: isCardLarge,
            "data-id": "dashboard_PlanningCard_ReadMoreBtn"
          }, __jsx(ButtonSecondary, {
            label: "Lees meer",
            type: "button",
            link: "#",
            size: isCardLarge ? 'normal' : 'small',
            "data-id": "dashboard_PlanningCard_ButtonSecondary"
          })));
      }
    });
    return _this;
  }
  _inherits(PlanningCard, _Component);
  return _createClass(PlanningCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      return __jsx(Card, {
        onClick: function onClick(evt) {
          return props.handleClick(evt, 'read');
        },
        "data-e2e-planningcard": true,
        "data-e2e-planningcard-type": props.type,
        "data-e2e-planningcard-title": props.title,
        "data-id": "dashboard_PlanningCard_Card"
      }, __jsx(ObserveSize, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "dashboard_PlanningCard_ObserveSize"
      }, this.renderCard(props)));
    }
  }]);
}(Component);
export default withMatch(
// $FlowFixMe
connect(null, mapDispatchToProps)(PlanningCard));
var PassedEventNotification = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12rem;\n  line-height: 16rem;\n  font-weight: bold;\n  color: ", ";\n  margin: 0;\n  position: absolute;\n  bottom: ", "rem;\n  left: ", "rem;\n"])), fonts.primary, colorPalette.beige, function (props) {
  return props.isCardLarge ? '25' : '15';
}, function (props) {
  return props.isCardLarge ? '25' : '15';
});
var DeleteIconContainer = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 15rem;\n  bottom: 15rem;\n  padding: 0 5rem;\n\n  > * {\n    transform: scale(1);\n  }\n\n  svg * {\n    transition: fill 0.2s ease-in-out;\n  }\n"])));
var CheckContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", ";\n"])), function (props) {
  return props.isCardLarge ? "\n    right: 5rem;\n    top: 2rem;\n  " : "\n    right: 1rem;\n    top: 2rem;\n    > svg {\n      transform: scale(.8);\n    }\n  ";
});
var UpdateContainter = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"])));
var DaysCounterWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "rem;\n  right: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? '17' : '12';
}, function (props) {
  return props.isCardLarge ? '20' : '15';
});
var CreatedBy = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n"])), fonts.primary, colorPalette.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '18' : '16';
});
var Author = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 5rem;\n\n  > div {\n    margin-right: 5rem;\n  }\n"])));
var Action = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-table;\n  margin-top: ", "rem;\n  margin-bottom: 8rem;\n  font-weight: bold;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n  padding-right: ", "rem;\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    border: 1px solid ", ";\n    border-radius: 4rem;\n    width: ", "rem;\n    height: ", "rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '10' : '8';
}, fonts.primary, colorPalette.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '26' : '18';
}, function (props) {
  return props.isCardLarge ? '36' : '28';
}, colorPalette.lightBeige, function (props) {
  return props.isCardLarge ? '24' : '16';
}, function (props) {
  return props.isCardLarge ? '24' : '16';
});
var SubTitle = styled.h4(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-top: 0rem;\n  margin-bottom: 8rem;\n  font-weight: bold;\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n"])), fonts.primary, colorPalette.textGrey, function (props) {
  return props.isCardLarge ? '14' : '12';
}, function (props) {
  return props.isCardLarge ? '20' : '10';
});
var StepIcon = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -2rem;\n  top: 0;\n  width: ", "rem;\n  height: ", "rem;\n  background-color: ", ";\n  border-radius: 6rem;\n  color: #ffffff;\n  text-align: center;\n  font-weight: bold;\n  font-family: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n\n  span {\n    position: relative;\n    display: block;\n    font-size: ", "rem;\n  }\n\n  &:before {\n    content: '';\n    z-index: -1;\n    border-radius: 6rem;\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n    opacity: 0.4;\n    position: absolute;\n    top: 4rem;\n    left: 4rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '40' : '32';
}, function (props) {
  return props.isCardLarge ? '40' : '32';
}, colorPalette.lightOrange, fonts.primary, function (props) {
  return props.isCardLarge ? '16' : '12';
}, function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '14' : '10';
}, colorPalette.lightOrange);
var IconHeader = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: relative;\n  min-height: ", "rem;\n\n  padding-left: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? "\n    ".concat(props.hasTime ? "75" : "55") : "\n    ".concat(props.hasTime ? "60" : "45");
}, function (props) {
  return props.isCardLarge ? '55' : '40';
});
var DateIconWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 45rem;\n\n  > * {\n    position: relative;\n    margin-top: 0;\n    margin-right: 0;\n    left: ", "rem;\n    top: ", "rem;\n  }\n"])), function (props) {
  return props.isCardLarge ? '-5' : '-10';
}, function (props) {
  return props.isCardLarge ? '-5' : '-10';
});
var TitleBig = styled.h3(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: block;\n  font-family: ", ";\n  font-size: ", "rem;\n  line-height: ", "rem;\n  margin-top: 0;\n  margin-bottom: 8rem;\n  box-sizing: border-box;\n  font-weight: bold;\n  color: ", ";\n"])), fonts.primary, function (props) {
  return props.isCardLarge ? '18' : '16';
}, function (props) {
  return props.isCardLarge ? '22' : '20';
}, colorPalette.headerGrey);
var PublishedDate = styled.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12rem;\n  line-height: 20rem;\n  margin-bottom: 5rem;\n  display: block;\n  color: ", ";\n"])), fonts.primary, function (props) {
  return props.color ? props.color : colorPalette.textGrey;
});
var ReadMoreBtn = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: ", "rem;\n  right: ", "rem;\n"])), function (props) {
  return props.isCardLarge ? '20' : '15';
}, function (props) {
  return props.isCardLarge ? '20' : '15';
});
var ImageContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background-color: #000000;\n\n  > * {\n    opacity: 0.8;\n  }\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  > svg {\n    position: absolute;\n    z-index: 3;\n    box-shadow: 0 0 200rem 0 rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    backface-visibility: hidden;\n    transform: translateZ(0);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"])));
var Card = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  margin-bottom: 20rem;\n  background-color: #ffffff;\n  ", ";\n  transition: box-shadow 0.25s ease;\n\n  &:hover {\n    box-shadow: 0rem 0rem 20rem 0rem rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n  }\n\n  > * {\n    height: 100%;\n  }\n"])), shadows.boxPrimary);
var Title = styled.h3(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  margin: 0;\n  color: #ffffff;\n  font-weight: bold;\n  font-size: ", "rem;\n  line-height: ", "rem;\n  color: ", ";\n"])), fonts.primary, function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '22' : '18';
}, function (props) {
  return props.type === 'update' ? '#FFFFFF' : colorPalette.textGrey;
});
var Text = styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-size: ", "rem;\n  line-height: ", "rem;\n  font-family: ", ";\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 0;\n"])), function (props) {
  return props.isCardLarge ? '18' : '14';
}, function (props) {
  return props.isCardLarge ? '28' : '22';
}, fonts.primary, colorPalette.textGrey);
var TextContainer = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n  padding: ", "rem;\n  box-sizing: border-box;\n"])), function (props) {
  return props.isCardLarge ? '20' : '15';
});